import React, { useState } from "react";
import Header from "./header";
import Swal from "sweetalert2";
import { uploadAttachment, uploadTicket } from "../utils/apiHelpDesk";

const ModalGenerateTickets = ({ setShowModal, applicationInfo, userName }) => {
  const [usermail, setUsermail] = useState("");
  const [subject, setsubject] = useState("");
  const [description, setDescription] = useState("");
  const [attachments, setAttachments] = useState([]);

  const handleFileChange = (event) => {
    setAttachments([...event.target.files]); // convertir FileList a array
  };
  const uploadNewTicket = async () => {
    console.log("Se va a guardar ticket");
    let attachmentsUpload = false;
    let flagUpload = true;
    if (
      usermail != "" &&
      subject != "" &&
      description != "" &&
      applicationInfo != "" &&
      userName != ""
    ) {
      console.log("Los campos requeridos son validos");

      if (attachments.length > 0) {
        console.log("Existe imagen y se debe subir");
        console.log(attachments[0]);
        console.log(attachments[0].type);
        if (
          attachments[0].type == "image/png" ||
          attachments[0].type == "image/jpg" ||
          attachments[0].type == "image/jpeg"
        ) {
          console.log("formato valido");
          attachmentsUpload = true;
        } else {
          console.log("formato no valido");
          let result_error = await Swal.fire({
            title: "Invalid attached document",
            icon: "error",
            text: "The attached document is not mandatory, but if required, it must be in png, jpg, and jpeg formats.",
            confirmButtonColor: "#3085d6",
            customClass: {
              confirmButton:
                "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            },
            buttonsStyling: false,
          });
          flagUpload = false;
        }
      }

      if (flagUpload) {
        const result = await Swal.fire({
          title: "Do you want to send the ticket?",
          text: "Remember to review the requested information before submitting the ticket.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, send",
          cancelButtonText: "Cancel",
          customClass: {
            confirmButton:
              "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
            cancelButton:
              "bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded ml-2",
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          console.log("Se puede subir finalmente");

          let tokenAttachment = [];

          if (attachmentsUpload) {
            console.log("Debo cargar imagen a API");
            let result_token = await uploadAttachment(attachments[0]);
            console.log(result_token);
            tokenAttachment.push(result_token);
          }

          if (attachmentsUpload && tokenAttachment.length < 1) {
            let result_error = await Swal.fire({
              title: "Error uploading ticket",
              icon: "error",
              text: "Error uploading ticket, please try again.",
              confirmButtonColor: "#3085d6",
              customClass: {
                confirmButton:
                  "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
              },
              buttonsStyling: false,
            });
          } else {
            const nowDatetime = new Date();
            const formattedDate = nowDatetime
              .toISOString()
              .slice(0, 19)
              .replace("T", " ");
            // 👆 esto da "YYYY-MM-DD HH:mm:ss"

            const body_header = `Fecha de creacion: ${formattedDate}\n\n`;

            let newTicketUpload = {
              ticket: {
                subject: applicationInfo + ": " + subject,
                comment: {
                  body: body_header + description,
                  uploads: tokenAttachment,
                },

                custom_fields: {
                  id: 41569744927636,
                  value: "en"
                },
                requester: {
                  email: usermail,
                  name: userName,
                  locale: "en",
                },
                email_ccs: [{ email: "fernando.riquelme@modelmining.com" }],
              },
            };

            let result_ticket = await uploadTicket(newTicketUpload);
            if (result_ticket.success) {
              let result_correct = await Swal.fire({
                title: "The ticket was sent",
                icon: "success",
                text: "Your ticket will be answered shortly.",
                confirmButtonColor: "#3085d6",
                customClass: {
                  confirmButton:
                    "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
                },
                buttonsStyling: false,
              });
              if (result_correct.isConfirmed) {
                setShowModal(false);
              }
            } else {
            }
          }
        }
      }
    } else {
      let result_error = await Swal.fire({
        title: "Incomplete fields",
        icon: "error",
        text: "There are fields that are mandatory",
        confirmButtonColor: "#3085d6",
        customClass: {
          confirmButton:
            "bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
        },
        buttonsStyling: false,
      });
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ">
      <div className="bg-gray-200 rounded-lg w-full max-w-3xl shadow-lg max-h-[95vh] overflow-y-auto">
        <div className="mt-22">
          <div className="flex justify-center mb-6 p-3">
            <h2 className="text-2xl font-bold tracking-wide">New Ticket</h2>
          </div>

          <div class="m-10 grid gap-4  grid-cols-[repeat(auto-fit,minmax(150px,1fr))]">
            <div class="col-span-2">
              <label for="first-name" class="block text-sm/6 font-bold ">
                Application Name
              </label>
              <div class="mt-2">
                <input
                  id="first-name"
                  type="text"
                  class="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2"
                  readOnly
                  value={applicationInfo}
                />
              </div>
            </div>
            <div class="col-span-2">
              <label for="first-name" class="block text-sm/6 font-bold">
                Username
              </label>
              <div class="mt-2">
                <input
                  id="first-name"
                  type="text"
                  class="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2"
                  readOnly
                  value={userName}
                />
              </div>
            </div>

            <div class="sm:col-span-4">
              <label for="username" class="block text-sm/6 font-bold">
                Email *
              </label>
              <div class="mt-2">
                <input
                  id="username"
                  type="text"
                  name="username"
                  class="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2"
                  value={usermail}
                  onChange={(e) => setUsermail(e.target.value)}
                />
              </div>
            </div>

            <div class="sm:col-span-4">
              <label for="username" class="block text-sm/6 font-bold">
                Subject *
              </label>
              <div class="mt-2">
                <input
                  id="username"
                  type="text"
                  name="username"
                  class="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2"
                  value={subject}
                  onChange={(e) => setsubject(e.target.value)}
                />
              </div>
            </div>

            <div class="sm:col-span-4">
              <label for="about" class="block text-sm/6 font-bold ">
                Description *
              </label>
              <div class="mt-2">
                <textarea
                  id="about"
                  name="about"
                  rows="3"
                  class="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>

            <div className="col-span-4">
              <label className="mt-2 block w-full text-sm font-bold">
                Attachments
              </label>
              <div className="mt-2 flex justify-center rounded-lg border px-6 py-2 bg-white">
                <div className="text-center">
                  <label
                    htmlFor="file-upload"
                    className="cursor-pointer font-semibold text-indigo-600"
                  >
                    <span>Upload a file</span>
                    <input
                      id="file-upload"
                      type="file"
                      multiple
                      className="sr-only"
                      onChange={handleFileChange}
                      accept=".png, .jpg, .jpeg"
                    />
                  </label>
                  <ul className="mt-4 text-sm text-gray-700">
                    {attachments.map((file, idx) => (
                      <li
                        key={idx}
                        className="flex justify-between items-center"
                      >
                        <p>{file.name} </p>
                        <p
                          className="text-red-500 cursor-pointer ml-1 font-bold"
                          onClick={() => setAttachments([])}
                        >
                          X
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-2 my-5 grid grid-cols-2 gap-4">
            <div class="col-span-1 flex justify-center">
              <button
                className="w-4/5 bg-red-500 text-white px-4 py-2 rounded mr-2"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
            </div>
            <div class="col-span-1 flex justify-center">
              <button
                className="w-4/5 bg-blue-500 text-white px-4 py-2 rounded"
                onClick={uploadNewTicket}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalGenerateTickets;
